/**
 * unit-marketing-vocabulary.ts — the canonical values of a unit marketing profile's property type and
 * physical attributes (ADR-LS-007: snake_case, never a listing site's wire values).
 *
 * Browser-safe (no dependencies): the API validates profiles against these lists, and the listing
 * extension's site adapters key their option maps by them, so a value added here fails the extension's
 * typecheck until every adapter decides how to fill it.
 */
export const PROPERTY_TYPES = ['apartment', 'house', 'condo', 'townhouse', 'room', 'studio'];
export const PARKING_TYPES = ['none', 'street', 'garage', 'covered', 'carport', 'driveway'];
export const LAUNDRY_TYPES = ['in_unit', 'shared', 'hookups', 'none', 'other', 'washer_only'];
export const COOLING_TYPES = ['central', 'window', 'mini_split', 'evaporative', 'geothermal', 'wall', 'solar', 'none', 'other'];
export const HEATING_TYPES = ['forced_air', 'heat_pump', 'baseboard', 'radiant', 'radiator', 'stove', 'wall', 'electric', 'none', 'other'];
//# sourceMappingURL=unit-marketing-vocabulary.js.map